import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./AuthConfirmationMessage.html';
import styles from './AuthConfirmationMessage-hashed.scss';

// VARS
var hashedTemplate = cssUtil.hashTemplate(template, styles);

// EXPORT
export default {
    template: hashedTemplate,
    bindings: {
        title: '@',
        message: '@'
    },
    controller: ['$state', function ($state) {
        // VARS
        var $ctrl = this;
        $ctrl.backToSignIn = function () {
            $state.go('authLogin');
        };
    }]
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-angular/components/common/AuthConfirmationMessage/index.js
// module id = 1334
// module chunks = 0